import { cropNumber } from "../../../../common/helpers/helpers";

export const getProp = (value) => {
  const propMin = 0.00001;
  const propMax = 1 - propMin;
  if (value < propMin) {
    return "0.00%";
  }
  if (value > propMax) {
    return "100%";
  }
  const formattedValue = cropNumber(value * 100, 2);
  return `${formattedValue}%`;
};
